export const encodeURIComponentIfNeeded = (p: string) => {
  const encoded = encodeURIComponent(p);
  try {
    return decodeURIComponent(p) === p ? encoded : p;
  } catch {
    return encoded;
  }
};
